import { PerpVaultABI } from "./abis/PerpABI.js";
import { isTestnet } from "../config/network";

export const NIBIRU_EVM_CHAIN = {
  chainId: isTestnet() 
    ? (process.env.REACT_APP_TESTNET_EVM_CHAIN_ID || "0x1AFF")
    : (process.env.REACT_APP_NIBIRU_EVM_CHAIN_ID || "0x1AF4"),
  chainName: isTestnet() ? "Nibiru Testnet" : "Nibiru Mainnet",
  nativeCurrency: {
    name: "NIBI",
    symbol: "NIBI",
    decimals: 18
  },
  rpcUrls: isTestnet()
    ? [process.env.REACT_APP_TESTNET_EVM_RPC || "https://evm-rpc.testnet-2.nibiru.fi"]
    : [process.env.REACT_APP_NIBIRU_EVM_RPC || "https://evm-rpc.nibiru.fi"],
  blockExplorerUrls: isTestnet() 
    ? [process.env.REACT_APP_TESTNET_BLOCK_EXPLORER || "https://testnet.nibiscan.io"]
    : ["https://nibiscan.io"]
};

export const PERP_VAULT_INTERFACE_ADDRESS = isTestnet()
  ? (process.env.REACT_APP_SAI_EVM_INTERFACE_ADDRESS || process.env.REACT_APP_TESTNET_EVM_CONTRACT_ADDRESS || '')
  : (process.env.REACT_APP_SAI_EVM_INTERFACE_ADDRESS || '');

export const PERP_VAULT_INTERFACE_ABI = PerpVaultABI;
export const WASM_PRECOMPILE_ADDRESS = "0x0000000000000000000000000000000000000802";